import React from 'react';
import { CheckCircle, Home } from 'lucide-react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const requestId = searchParams.get('requestId');

  return (
    <div className="min-h-screen gradient-pastel flex items-center justify-center p-4">
      <div className="card max-w-2xl w-full text-center">
        <div className="w-24 h-24 gradient-primary rounded-full flex items-center justify-center mx-auto mb-6 shadow-soft-lg">
          <CheckCircle className="w-12 h-12 text-white" />
        </div>

        <h1 className="text-3xl font-bold text-luma-text mb-4">
          Payment Successful!
        </h1>

        <p className="text-lg text-luma-text-light mb-6">
          Thank you for your payment. Your consultation has been completed and paid for.
        </p>

        <div className="bg-luma-accent rounded-2xl p-6 mb-8">
          <div className="grid md:grid-cols-2 gap-4 text-left">
            <div>
              <p className="text-sm text-luma-text-light mb-1">Amount Paid</p>
              <p className="text-2xl font-bold text-luma-primary">$19.99</p>
            </div>
            {requestId && (
              <div>
                <p className="text-sm text-luma-text-light mb-1">Request ID</p>
                <p className="text-lg font-mono text-luma-text">{requestId}</p>
              </div>
            )}
          </div>
        </div>

        <div className="space-y-4">
          <p className="text-sm text-luma-text-light">
            A receipt has been sent to your email address.
          </p>

          <button
            onClick={() => navigate('/')}
            className="btn-primary inline-flex items-center"
          >
            <Home className="w-5 h-5 mr-2" />
            Return to Home
          </button>
        </div>

        <div className="mt-8 pt-6 border-t border-luma-border">
          <p className="text-xs text-luma-text-light">
            If you have any questions about your consultation or payment, please contact our support team.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
